import { Box, Button, Typography } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ACCENT = "#155f52";

interface DonationSuccessOverlayProps {
  open: boolean;
  onClose: () => void;
  message?: string;
}

export default function DonationSuccessOverlay({
  open,
  onClose,
  message = "Thank you for your support",
}: DonationSuccessOverlayProps) {
  return (
    <AnimatePresence>
      {open && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ type: "spring", damping: 20, stiffness: 300 }}
            style={{ pointerEvents: "auto" }}
          >
            <Box
              sx={{
                bgcolor: "#fff",
                borderRadius: "18px",
                px: 4,
                py: 3.5,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
                minWidth: 260,
                boxShadow: "0 12px 40px rgba(0,0,0,0.3)",
              }}
            >
              <CheckCircleIcon sx={{ color: ACCENT, fontSize: 48 }} />
              <Typography sx={{ color: "#111827", fontWeight: 700, fontSize: "1.1rem" }}>
                Donation Received!
              </Typography>
              <Typography sx={{ color: "#4b5563", fontSize: "0.8rem", textAlign: "center" }}>
                {message}
              </Typography>
              <Button
                onClick={onClose}
                sx={{
                  mt: 1.5,
                  bgcolor: ACCENT,
                  color: "#fff",
                  borderRadius: "999px",
                  textTransform: "none",
                  fontWeight: 700,
                  px: 3,
                  "&:hover": { bgcolor: "#0e463c" },
                }}
              >
                Continue Watching
              </Button>
            </Box>
          </motion.div>
        </Box>
      )}
    </AnimatePresence>
  );
}
